<template>
  <div class="rich-text">
    <editor-content :class="['rich-text__content']" :editor="editor"/>
  </div>
</template>

<script>
import { Editor, EditorContent } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  components: {
    EditorContent
  },
  props: {
    text: String
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        editable: false,
        content: ''
      }),
    }
  },
  methods: {
    setContent (content) {
      this.editor.setContent(content)
    }
  },
  mounted () {
    this.setContent(this.text)
  },
  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>
<style lang="scss">
.rich-text {
  .ProseMirror {
    &:focus {
      outline: 0;
    }
  }
}
</style>